// Re-export types
export type { QuestionConfig, CategoryQuestions } from './types';

// Re-export constants
export { bodyParts } from './constants';

// Import core category questions
import { sleepQuestions } from './categories/sleep';
import { meditationQuestions } from './categories/meditation';
import { anxietyQuestions } from './categories/anxiety';
import { massageQuestions } from './categories/massage';
import { motivationQuestions } from './categories/motivation';
import { memoryQuestions } from './categories/memory';
import { beStillQuestions } from './categories/be_still';
import { selfLoveQuestions } from './categories/self_love';
import { fitnessQuestions } from './categories/fitness';
import { newsMeditationQuestions } from './categories/news_meditation';
import { yogaQuestions } from './categories/yoga';
import { zenAfQuestions } from './categories/zen_af';
import { addictionRecoveryQuestions } from './categories/addiction_recovery';
import { couplesConnectionQuestions } from './categories/couples_connection';
import { relationshipDecisionsQuestions } from './categories/relationship_decisions';
import { sexualWellnessWomenQuestions } from './categories/sexual_wellness_women';
import { celebrationQuestions } from './categories/celebration';
import { mensEmpowermentQuestions } from './categories/mens_empowerment';
import { womensEmpowermentQuestions } from './categories/womens_empowerment';

// Export combined categoryQuestions object for core categories
export const categoryQuestions: Record<string, any> = {
  sleep: sleepQuestions,
  meditation: meditationQuestions,
  anxiety: anxietyQuestions,
  massage: massageQuestions,
  motivation: motivationQuestions,
  memory: memoryQuestions,
  be_still: beStillQuestions,
  self_love: selfLoveQuestions,
  fitness: fitnessQuestions,
  life_celebrations: celebrationQuestions,
  'news-meditation': newsMeditationQuestions,
  'yoga-meditation': yogaQuestions,
  'zen-af': zenAfQuestions,
  'addiction-recovery-men': addictionRecoveryQuestions,
  'couples-connection': couplesConnectionQuestions,
  'relationship-decisions': relationshipDecisionsQuestions,
  'sexual-wellness-women': sexualWellnessWomenQuestions,
  'mens-empowerment': mensEmpowermentQuestions,
  'womens-empowerment': womensEmpowermentQuestions
};